<template>
    <v-container
        class="d-flex flex-column flex-grow-1"
        style="min-height: 80vh;"
        fluid
    >
        <client-only>
            <ProductCatalogPanel
                :current-deeplink="currentDeeplink"
                @on-path-change="onPathChange"
            >
                <template
                    #default="{ modelValue, loadingStatus }"
                >
                    <NuxtPage
                        :modelValue="modelValue"
                        :loadingStatus="loadingStatus"
                    ></NuxtPage>
                </template>
            </ProductCatalogPanel>
        </client-only>
    </v-container>
</template>

<script lang="ts" setup>
    import { getSingleParam } from 'x1-base/utils';
    import type { ProductCatalogMenuSelection } from '~/types';
    import { pathJoin } from 'x1-base/utils';

    const ProductCatalogPanel = defineAsyncComponent(() => import('~/components/product-catalog/ProductCatalogPanel/ProductCatalogPanel.vue'));

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Product Catalog | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Product Catalog'
            }
        ]
    });

    const route = useRoute();
    const currentDeeplink = ref<Nilish<string>>(getSingleParam(route.params, 'deeplink'));

    async function onPathChange(selection: Nullable<ProductCatalogMenuSelection>): Promise<void> {
        let newPath = `/product-catalog`;

        if (selection) {
            const { path } = selection;
            currentDeeplink.value = path;
            newPath = pathJoin(newPath, path);
        }

        await navigateTo({
            path: newPath,
            query: route.query,
            replace: true
        });
    }
</script>
